<template>
  <div class="app-options-success">
    <div class="success-heading"><slot name="successHeading"><h2>Vielen Dank!</h2></slot></div>
    <OptionsTable
      v-if="showSuccessComponent"
      class="success-table"
      :options="successfulOptions"
      :success-table="true"
      :is-deactivate="isDeactivate"
    >
      <template v-for="slot in possibleChildSlotsFor('TableSuc')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </OptionsTable>
    <OptionsTable v-if="showErrorComponent" class="error-table" :options="failedOptions" :success-table="false">
      <template v-for="slot in possibleChildSlotsFor('TableError')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </OptionsTable>
    <div class="txt-after-success">
      <slot name="txtAfterSuccess"></slot>
    </div>
    <Stepper
      :show-prev="true"
      :show-next="false"
      @prev="prev"
      :loading-prev="loadingPrev"
    >
    </Stepper>
  </div>
</template>

<script>

import Stepper from '../../../../../generic/Stepper.vue'
import OptionsTable from './OptionsTable.vue'
import slotProxy from '@/mixins/slotProxy'
import processSteps from '@/mixins/processSteps'
import { stepName as viewStep } from '../View.vue'

const mapOptions = function (optionArray, dataObj) {
  return optionArray.map(option => {
    return Object.assign(
      {},
      option,
      dataObj.find(o => o.tariffoptionId === option.tariffoptionId)
    )
  })
}

export const stepName = 'success'
export default {
  name: 'OptionsSuccess',
  components: { Stepper, OptionsTable },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    errorOptions: {
      type: Array,
      default: () => []
    },
    successOptions: {
      type: Array,
      default: () => []
    },
    isDeactivate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    failedOptions () {
      return mapOptions(this.errorOptions, this.options)
    },
    successfulOptions () {
      return mapOptions(this.successOptions, this.options)
    },
    showSuccessComponent () {
      return this.successfulOptions !== null && this.successfulOptions.length > 0
    },
    showErrorComponent () {
      return this.failedOptions !== null && this.failedOptions.length > 0
    }
  },
  methods: {
    prev () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.$emit('update-step', this.previousStep)
    }
  },
  mixins: [
    slotProxy(),
    processSteps(stepName, viewStep, stepName)
  ],
  data () {
    return {
      loadingPrev: false
    }
  }
}
</script>
